import HeroVideo from '../components/HeroVideo'
import HoverSections from '../components/HoverSections'
import HeroBanner from '../components/HeroBanner'
import Testimonials from '../components/Testimonials'

export default function Home() {
  return (
    <>
      <HeroVideo />
      <HoverSections />
      <Testimonials />
      <HeroBanner />
    </>
  )
}
